import { initializeApp } from 'firebase/app';
import { getAuth, signInWithEmailAndPassword, createUserWithEmailAndPassword, deleteUser, onAuthStateChanged, signOut } from 'firebase/auth';
import { getDatabase, ref, set, get, onValue, remove, update, push, off } from 'firebase/database';

const firebaseConfig = {
  apiKey: "AIzaSyBGZ48zEvm5zS7agHj3Icik-4KWA8Ls6X0",
  authDomain: "commbook-2077.firebaseapp.com",
  databaseURL: "https://commbook-2077-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "commbook-2077",
  storageBucket: "commbook-2077.firebasestorage.app",
  messagingSenderId: "533805252588",
  appId: "1:533805252588:web:3ab7248bba18a822018ac9",
  measurementId: "G-DVNXNMXXHX"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const database = getDatabase(app);

export { auth, database, signInWithEmailAndPassword, createUserWithEmailAndPassword, deleteUser, onAuthStateChanged, signOut, ref, set, get, onValue, remove, update, push, off };